import "bootstrap/dist/css/bootstrap.min.css";
import "./BannerMarquee.css";
import back from "../../../../Assets/Images/Services/Web Development/cloud-programming.svg";
import WebMain from "../../../../Assets/Images/Services/Web Development/Web-Maintenance.svg";
import UiUx from "../../../../Assets/Images/Services/Web Development/UX UI.svg";
import custom from "../../../../Assets/Images/Services/Web Development/Custom Software-Outline icon.svg";
import ecommerce from "../../../../Assets/Images/Services/Web Development/E-commerce-icon.svg";
import pwa from "../../../../Assets/Images/Services/Web Development/PWAs.svg";
import content from "../../../../Assets/Images/Services/Web Development/content-management.svg";
import webApp from "../../../../Assets/Images/Services/Web Development/Web App.svg";
import api from "../../../../Assets/Images/Services/Web Development/cloud-api.svg";
import front from "../../../../Assets/Images/Services/Dev For Hire/Front-End developer.svg";

export const BannerMarquee = () => {
  return (
    <div className="services-offer-continer">
      <div className="text-center">
        <h1 className="service-offer-title">Services We Offer</h1>
      </div>
      <div className="service-offer-slider">
        <div className="services-offer so d-flex">
          <div className="lbs d-flex flex-column justify-content-center align-items-center">
            <img src={front} alt="mobile consulting" className="" />
            <p>Frontend Development</p>
          </div>
          <div className="dbs d-flex flex-column justify-content-center align-items-center">
            <img src={back} alt="mobile consulting" className="" />
            <p>Backend Development</p>
          </div>
          <div className="lbs d-flex flex-column justify-content-center align-items-center">
            <img src={WebMain} alt="web consulting" className="" />
            <p>Web Maintenance & Support</p>
          </div>
          <div className="dbs d-flex flex-column justify-content-center align-items-center">
            <img src={UiUx} alt="mobile consulting" className="" />
            <p>Website Maintenance and Support</p>
          </div>
          <div className="lbs d-flex flex-column justify-content-center align-items-center">
            <img src={custom} alt="web consulting" className="" />
            <p>Custom Web Development</p>
          </div>
          <div className="dbs d-flex flex-column justify-content-center align-items-center">
            <img src={ecommerce} alt="mobile consulting" className="" />
            <p>E-commerce Development </p>
          </div>
          <div className="lbs d-flex flex-column justify-content-center align-items-center">
            <img src={pwa} alt="web consulting" className="" />
            <p>Website Optimisation and Performance</p>
          </div>
          <div className="dbs d-flex flex-column justify-content-center align-items-center">
            <img src={content} alt="mobile consulting" className="" />
            <p>CMS Based Development</p>
          </div>
          <div className="lbs d-flex flex-column justify-content-center align-items-center">
            <img src={webApp} alt="web consulting" className="" />
            <p>Web Application Development</p>
          </div>
          <div className="dbs d-flex flex-column justify-content-center align-items-center">
            <img src={api} alt="mobile consulting" className="" />
            <p>API Integration and Development</p>
          </div>
        </div>
      </div>
    </div>
  );
};
